<template>
  <div class="row">
    <div class="col-md-12" v-if="videos.length">
      <div class="panel panel-noborder profile-panel profile-highlights">
        <edit-button modal-target="editHighlights" />
        <h3 class="text-center tw-mb-10">{{$t('wi.highlight_videos')}}</h3>
        <div class="row videoplayer">
          <div class="col-md-8 videoplayer-video pd-vert-0">
            <video
              id="video-highlight"
              controls
              class="video-js vjs-default-skin"
            >
              <source type="video/mp4" :src="videoToPlay.video" />
            </video>
          </div>
          <div class="col-md-4 pd-vert-0">
            <div class="text-muted video-count">
              <small>{{ videos.length }} {{$t('wi.videos')}}</small>
            </div>
            <div class="videoplayer-playlist">
              <play-list-item
                v-for="(video, index) in videos"
                :key="video.id"
                :id="video.id"
                :title="video.name"
                :thumbnail="video.thumbnail"
                :is-active="index === playIndex"
                :src="video.video"
                :uploaded-at="video.uploaded_at"
                @selected="gotoVideo(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="col-md-8 col-md-offset-2">
      <empty-state
        class="panel profile-panel tw-h-auto"
        :description="$t('wi.actions_speak_louder_than_words')"
        :title="$t('wi.highlight_videos')"
        :button="{ caption: $t('wi.add_highlight_videos') }"
        modalTarget="editHighlights"
      />
    </div>
  </div>
</template>
<script type="text/babel">
import { mapGetters } from 'vuex';
import EditButton from '../VisualElements/EditButton';
import PlayListItem from './PlayListItem';
import EmptyState from '../EmptyState';

export default {
  name: 'HighlightVideos',
  components: {
    EditButton,
    PlayListItem,
    EmptyState
  },
  data() {
    return {
      playIndex: 0
    };
  },
  props: {
    profileType: {
      type: String,
      default: 'blast'
    }
  },
  watch: {
    videos(videos) {
      let videoInstance = document.getElementById('video-highlight');
      videoInstance.removeAttribute('src');
      videoInstance.load();
      this.playIndex = 0;
    }
  },
  computed: {
    ...mapGetters({
      roles: 'player-profile/roles',
      videosData: 'player-profile/profileVideos'
    }),
    videoToPlay() {
      return this.videos[this.playIndex];
    },
    videos() {
      return this.videosData;
    }
  },
  methods: {
    gotoVideo(index) {
      if (this.profileType === 'blast') {
        trackEvent('ga-profile-view-video-highlight');
      } else {
        trackEvent('ga-ncsa-clicked-video-highlight');
      }
      let videoInstance = document.getElementById('video-highlight');
      videoInstance.removeAttribute('src');
      this.playIndex = index;
      this.$nextTick(() => {
        videoInstance.load();
        videoInstance.play();
      });
    }
  },
  mounted() {
    let videoInstance = document.getElementById('video-highlight');
    if (videoInstance) {
      videoInstance.onended = () => {
        videoInstance.removeAttribute('src');
        if (this.playIndex + 1 < this.videos.length) {
          this.playIndex++;
          this.$nextTick(() => {
            videoInstance.load();
            videoInstance.play();
          });
        }
      };
    }
  }
};
</script>
